import { isArray } from "lodash";
import {
  CalendarListCategory,
  ICalendar,
  ICalendarList,
  ISortedCalendars,
} from "src/Pages/Company/Absences/Calendars/Calendars.models";

/**
 * Function transforming default API data to structure ready for render in three lists (past, present & future) sorted by year.
 * @param {array} data - collection of calendars from API.
 * @returns {ISortedCalendars} - object with years as keys and calendars array as values.
 */
export default (data: ICalendar[]) => {
  if (!isArray(data)) return {};

  const currentYear: number = new Date().getFullYear();

  const result: ICalendarList = {
    [CalendarListCategory.FUTURE]: {},
    [CalendarListCategory.PRESENT]: {},
    [CalendarListCategory.PAST]: {},
  };

  data.forEach((calendar): void => {
    const yearNum: number = parseInt(calendar.year, 10);

    let category: keyof ICalendarList;
    if (yearNum < currentYear) {
      category = CalendarListCategory.PAST;
    } else if (yearNum === currentYear) {
      category = CalendarListCategory.PRESENT;
    } else {
      category = CalendarListCategory.FUTURE;
    }

    if (!result[category][yearNum]) {
      result[category][yearNum] = [];
    }

    result[category][yearNum].push(calendar);
  });

  // Sort calendars within each year by name
  Object.entries(result).forEach(([category, calendarsInCategory]) => {
    const typedCategory = category as keyof ICalendarList;

    Object.keys(calendarsInCategory).forEach((year) => {
      const yearNum = parseInt(year, 10);
      result[typedCategory][yearNum] = [...calendarsInCategory[yearNum]].sort(
        (a, b) => a.name.localeCompare(b.name)
      );
    });
  });

  return result;
};
